import { FC } from 'react';
import { useSelector } from 'react-redux';

import { Loader } from 'src/components/Loader/Loader';
import { getAdminState } from 'src/store/admin/selectors';
import { BookingObject, PlaceType } from 'src/types';

import { DeskSidesheet } from './BookingObjects/DeskSidesheet';
import { ParkingSidesheet } from './BookingObjects/ParkingSidesheet';
import { RoomSidesheet } from './BookingObjects/RoomSidesheet';

interface InnerProps {
  bookingObject: BookingObject;
}

const Inner: FC<InnerProps> = ({ bookingObject }) => {
  switch (bookingObject.type) {
    case PlaceType.Desk:
      return <DeskSidesheet bookingObject={bookingObject} />;
    case PlaceType.Room:
      return <RoomSidesheet bookingObject={bookingObject} />;
    case PlaceType.Parking:
      return <ParkingSidesheet bookingObject={bookingObject} />;
    default:
      return null;
  }
};

export const AdminSidesheetPanel: FC = () => {
  const { selectedPlace } = useSelector(getAdminState);

  if (!selectedPlace) return <Loader />;

  return <Inner bookingObject={selectedPlace} />;
};
